import React from 'react'
import SnackBar from './NormalSnackBar';

class ShareButton extends React.Component{
    constructor (props) {
        super(props)
        this.state = {
            open: false
        }
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
        navigator.clipboard.writeText(window.location.href); 

        if(this.state.open){
            this.setState({
                open: false
            })    
        }else{
            this.setState({
                open: true
            })   
        }
    }

    render () {
        return (
        <div>
            <svg
                onClick={this.handleClick}
                height="128pt"
                viewBox="0,0,128,128"
                style= {{
                    cursor: 'pointer',
                    width: 48,
                    height: 48,
                    float: 'right',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    stroke: '#343434',
                }}>
                    <path d="M96+80L96+96L32+96L32+32L48+32" strokeWidth="10" fill="none" opacity="1"/>
                    <path d="M64+32L96+32L96+64"  strokeWidth="10" fill="none" opacity="1"/>
                    <path d="M64+64L96+32"  strokeWidth="10" fill="none" opacity="1"/>
            </svg>
            <SnackBar open={this.state.open} onClose={this.handleClick} message='The share link has been copied to your clipboard'/>
        </div>
        )
  }
}

export default ShareButton